import Vue from "vue";

export default Vue.extend( {
  props: {
    content: {
      type: Object,
      required: true,
      default: () => {},
    },
    layout: {
      type: String,
      required: false,
      default: "",
    },
  },
  data () {
    return {
      altTitleKeys: ["pageHeading"],
    };
  },
  computed: {
    layoutClass () {
      return `layout-${this.layout}`;
    },
    displayName () {
      let result = "";
      const { name, searchTitle } = this.content;
      const searchTitleIsDefined = this.hasValue( searchTitle );
      const alternativeNameKey = this.altTitleKeys.find( key => key in this.content );

      if ( searchTitleIsDefined ) {
        result = this.content.searchTitle;
      } else {
        result = this.content[alternativeNameKey] || name;
      }

      return result?.replace( /&nbsp;|\xA0/g, " " ) ?? console.error( "[name property required]: check template config." );
    },
  },
  methods: {
    hasValue ( val ) {
      return val != null && val.length > 0;
    },
  },
} );
